/**
 * 
 * @param dateString 
 */
export default function createLocalDateFromString(dateString: string): Date {
  const [year, month, day] = dateString.split("-").map(Number);
  // Note: month is zero-based in JavaScript Date
  return new Date(year, month - 1, day);
}
